import loadImage from 'blueimp-load-image';
import { action, axiosReq } from './util';

export const PhotoActionType = {
  ERROR: 'PHOTO_ERROR',
  UPLOADING: 'PHOTO_UPLOADING',
  UPLOAD_SUCCESS: 'PHOTO_UPLOAD_SUCCESS',
  RESET: 'PHOTO_RESET',
};

export function resetPhoto() {
  return action(PhotoActionType.RESET);
}

export function uploadPhoto(file, noCompression) {
  return async dispatch => {
    dispatch(uploadingPhoto());
    const image = await getBase64(file, noCompression);
    axiosReq()
      .post('/api/upload-image', { image })
      .then(({ data }) => {
        dispatch(uploadPhotoSuccess(data.url));
      })
      .catch(err => {
        console.log(err);
        dispatch(errorPhoto('Image upload failed'));
      });
  };
}

export function uploadingPhoto() {
  return action(PhotoActionType.UPLOADING, {});
}

export function uploadPhotoSuccess(url) {
  return action(PhotoActionType.UPLOAD_SUCCESS, { url });
}

export function errorPhoto(error) {
  return action(PhotoActionType.ERROR, { error });
}

function getBase64(file, noCompression) {
  return new Promise((resolve, reject) => {
    loadImage(file, imageCanvas => {
      let exportedImage;
      if (noCompression) {
        exportedImage = getFullImage(imageCanvas);
      } else {
        exportedImage = downscaleImage(imageCanvas, 2000);
      }
      resolve(exportedImage.split(',')[1]);
    }, {
      orientation: true,
      canvas: true,
    });
  });
}

function downscaleImage(imageCanvas, newWidth) {
  const oldWidth = imageCanvas.width;
  const oldHeight = imageCanvas.height;
  let newHeight = Math.floor((newWidth / oldWidth) * oldHeight);

  // Don't stretch image
  if (newWidth > oldWidth) {
    newWidth = oldWidth;
    newHeight = oldHeight;
  }

  // Create a temporary canvas to draw the downscaled image on.
  const canvas = document.createElement('canvas');
  canvas.width = newWidth;
  canvas.height = newHeight;

  // Draw the downscaled image on the canvas and return the new data URL.
  const ctx = canvas.getContext('2d');
  // set background color
  ctx.fillStyle = '#ffffff';
  // draw background / rect on entire canvas
  ctx.fillRect(0, 0, newWidth, newHeight);
  ctx.drawImage(imageCanvas, 0, 0, newWidth, newHeight);
  return canvas.toDataURL('image/jpeg', 0.6);
}

function getFullImage(imageCanvas) {
  // Create a temporary canvas to draw the downscaled image on.
  const canvas = document.createElement('canvas');
  canvas.width = imageCanvas.width;
  canvas.height = imageCanvas.height;

  // Draw the downscaled image on the canvas and return the new data URL.
  const ctx = canvas.getContext('2d');
  // set background color
  ctx.fillStyle = '#ffffff';
  // draw background / rect on entire canvas
  ctx.fillRect(0, 0, imageCanvas.width, imageCanvas.height);
  ctx.drawImage(imageCanvas, 0, 0, imageCanvas.width, imageCanvas.height);
  return canvas.toDataURL('image/jpeg', 1.0);
}
